import React, { createContext, useState, useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import mixpanel from 'mixpanel-browser';
import qs from 'qs';
import { NotifContext } from './NotifContext';

const blogAPI = process.env.REACT_APP_API;

export const ArticleContext = createContext();

const ArticleContextProvider = (props) => {
  const [article, setArticle] = useState({});
  const [loading, setLoading] = useState(true);
  const [articlePrivacy, setArticlePrivacy] = useState('public');
  const { show } = useContext(NotifContext);

  const config = { withCredentials: true };

  const query = qs.parse(props.location.search.slice(1));

  const fetchArticle = () => {
    setLoading(true);
    const {
      match: { params },
    } = props;
    const localArticle = JSON.parse(localStorage.getItem('recentArticle'));
    if (
      localArticle &&
      localArticle.update.uid === params.uid &&
      !query.hardReload
    ) {
      setArticle(localArticle);
      setLoading(false);
    } else {
      const api = `${blogAPI}/articles/${params.uid}`;
      axios
        .get(api, config)
        .then((res) => {
          const response = res.data;
          if (response.error || response.code === 1) {
            mixpanel.track('Backend Error: Fetch One article', {
              api,
              response,
              has_token: Boolean(config.headers?.Authorization),
            });
            // error notif
            show('info', 'Error!', response.message, 'bottomRight');
            setLoading(false);
          } else {
            const newArticle = {
              user: response.payload.user,
              isPersonal: response.payload.isPersonal,
              isPrivate: response.payload.isPrivate,
              update: response.payload.article,
              message: response.message,
            };
            setArticlePrivacy(newArticle.update.privacy);
            // push to localstorage
            localStorage.setItem('recentArticle', JSON.stringify(newArticle));
            update('view', { article: newArticle.update.uid });
            // update article
            setArticle(newArticle);
            setLoading(false);
            // show('success', 'Success!', response.message, 'topRight');
          }
        })
        .catch((e) => {
          mixpanel.track('Error: Fetch One article', {
            api,
            has_token: Boolean(config.headers?.Authorization),
          });
          setLoading(false);
          show('error', 'Error!', 'Something went wrong!', 'bottomRight');
        });
    }
  };

  const update = (type, data) => {
    const types = ['delete', 'privacy', 'view'];
    if (types.includes(type)) {
      const api = `${blogAPI}/articles/update/${type}`;
      axios
        .post(api, data, config)
        .then((res) => {
          const response = res.data;
          if (response.error || response.code === 1) {
            mixpanel.track(`Backend Error: Update Article ${type}`, {
              api,
              response,
              data,
              has_token: Boolean(config.headers?.Authorization),
            });
            // error notif
            show('info', 'Error!', response.message, 'bottomRight');
          } else if (type === 'delete') {
            props.history.push({
              search: `?hardReload=true`,
            });
            fetchArticle();
            window.location.reload(true);
          } else if (type === 'privacy') {
            props.history.push({
              search: `?hardReload=true`,
            });
            fetchArticle();
          }
        })
        .catch((e) => {
          mixpanel.track(`Error: Update Article ${type}`, {
            api,
            data,
            has_token: Boolean(config.headers?.Authorization),
          });
          setLoading(false);
          show(
            'error',
            'Error!',
            `Something went wrong while updating ${type}!`,
            'topRight'
          );
        });
    } else {
      console.log('forbidden type!');
    }
  };

  useEffect(() => {
    fetchArticle();
  }, []);

  return (
    <ArticleContext.Provider
      value={{
        article,
        setArticle,
        fetchArticle,
        loading,
        update,
        articlePrivacy,
        setArticlePrivacy,
      }}
    >
      {props.children}
    </ArticleContext.Provider>
  );
};

export default withRouter(ArticleContextProvider);
